import { render } from "./LoadContentButton.vue?vue&type=template&id=1ed6cab1&scoped=true"
import script from "./LoadContentButton.vue?vue&type=script&lang=js"
export * from "./LoadContentButton.vue?vue&type=script&lang=js"

import "./LoadContentButton.vue?vue&type=style&index=0&id=1ed6cab1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed6cab1"]])

export default __exports__